import AuthConstants from "./authConstants";
import AuthService from "./authService";
import call from "../../../shared/service/http";
import {EventBus} from "../../../shared/utilities/event-bus";

export default {
    namespaced: true,
    state: {
        isLoggedIn:AuthService?.check(),
        isGamer:AuthService?.isAGamer(),
        terms: {},
        verification: null,
        alert: {
            status: "",
            message: "",
        },
        loading: false,
    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        AuthGetter: (state) => (setup) => state[setup],
    },
    actions: {
        /**
         * Register user
         * @param context
         * @param data
         */
        register: ({commit}, data) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            EventBus.$emit('submitting',true)
            call('post', AuthConstants.REGISTER, data)
                .then(res => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    EventBus.$emit('submitting',false)
                    console.log(res.data)
                    if (res.data.status) {
                        EventBus.$emit('ApiSuccess', res.data.message)
                        //
                        setTimeout(()=>{
                            // window.location.href="/auth/sign-in"
                        },1500)
                    }
                     else{
                        EventBus.$emit('ApiError', `${res.data.message}!`)
                    }
                })
                .catch((error) => {
                    EventBus.$emit('submitting',false)
                    EventBus.$emit('ApiError', `${error.response.data.message}!`)
                    commit('Dashboard/SET_LOADING', false, { root: true })
                })
        },
        /**
         * Login user
         * @param p
         * @param data
         */
        login: ({commit}, data) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            EventBus.$emit('submitting',true)
            call("post", AuthConstants.LOGIN, data)
                .then(res => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    EventBus.$emit('submitting',false)
                    if (res.data.status) {
                        EventBus.$emit('hasSentOTP',true)
                        EventBus.$emit("ApiSuccess", res.data.detail);
                        //
                    } else{
                        EventBus.$emit('loggedIn',false)
                        EventBus.$emit("ApiError",res.data.detail);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    EventBus.$emit('submitting',false)
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        /**
         * Login user
         * @param p
         * @param data
         */
        verifyIdentity: ({commit}, data) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            call("post", AuthConstants.VERIFY, data)
                .then(res => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    if (res.data.status) {
                        EventBus.$emit("ApiSuccess", res.data.detail);
                        //
                        AuthService.login(res.data)
                        setTimeout(()=>{
                            window.location.href="/dashboard/applications"
                        },1500)

                    } else{
                        EventBus.$emit("ApiError",res.data.detail);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    EventBus.$emit('submitting',false)
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        /**
         * Login user
         * @param p
         * @param data
         */
        verifyOTP: ({commit}, data) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            call("post", AuthConstants.VERIFY_OTP, data)
                .then(res => {
                    EventBus.$emit('submitting',false)
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    if (res.data.status) {
                        EventBus.$emit("OTPVerified",res.data.status)
                        EventBus.$emit("ApiSuccess", res.data?.detail || res.data?.message);

                    } else {
                        EventBus.$emit("ApiError",res.data.detail || res.data?.message);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    EventBus.$emit('submitting',false)
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        /**
         * Send password reset link
         * @param commit
         * @param data
         */
        sendResetPasswordLink: ({commit},data) => {
            commit("Dashboard/SET_LOADING", true, { root: true });
            call('post', AuthConstants.sendResetPasswordLink, data)
                .then((res) => {
                    commit("Dashboard/SET_LOADING", false, { root: true });
                    EventBus.$emit('submitting',false)
                    if (res.data.status) {
                        EventBus.$emit("hasSentCode",true)
                        EventBus.$emit('ApiSuccess', res.data?.message || res?.data?.detail)
                    } else{
                        EventBus.$emit('ApiError', res.data?.message || res?.data?.detail)
                    }
                })
                .catch((error) => {
                    commit("Dashboard/SET_LOADING", false, { root: true });
                    EventBus.$emit('submitting',false)
                    EventBus.$emit('ApiError', error.response.data.message)
                })
        },
        /**
         * Set new password on reset
         * @param context
         * @param data
         */
        setPassword: ({commit}, data) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            call('post', AuthConstants.setPassword, data)
                .then((res) => {
                    commit("Dashboard/SET_LOADING", false, { root: true });
                    EventBus.$emit('submitting',false)
                    EventBus.$emit('ApiSuccess', `${res?.data?.message || res?.data?.detail}, you can now login`)
                    //
                    setTimeout(() => {
                        window.location.href="/auth/login"
                    }, 1500)
                })
                .catch((e) => {
                    EventBus.$emit('submitting',false)
                    EventBus.$emit('ApiError', e.data.response.data.message)
                })
        },
        /**
         * Get user
         * @param commit
         * @param data
         */
        user: ({ commit }) => {
            commit("SET_ALERT", null);
            call("get", AuthConstants.user)
                .then((res) => {
                    AuthService.setUser(res.data.data);
                    commit('Dashboard/SET_LOADING', false, { root: true })
                })
                .catch((err) => {
                    commit("SET_LOADING", false, { root: true });
                    commit("SET_ALERT", {
                        status: "error",
                        message: err.response.data.message,
                    });
                });
        },

        logout: ({ commit }) => {
            commit("SET_LOADING", true, { root: true });
            call("post", AuthConstants.LOGOUT)
                .then(() => {
                    commit("SET_LOADING", false, { root: true });
                    commit("MUTATE",{
                        state:"isLoggedIn",
                        data:false
                    })
                    AuthService.logout();
                    EventBus.$emit("ApiSuccess", `You have successfully signed out! ${AuthService.user.name}!`);
                    setTimeout(() => {
                        AuthService.logout();
                    }, 2000);
                })
                .catch((err) => {
                    commit("SET_LOADING", false, { root: true });
                    commit("SET_ALERT", {
                        status: "error",
                        message: err.response.data.message,
                    });
                });
        }
    },
};
